(() => {
  window.Express = window.Express || {};

  function getHorizontalDragHelper() {
    return window.Express.productBuilderHorizontalDrag;
  }

  function attach(element, options = {}) {
    if (!element) return null;

    let startScrollLeft = 0;
    return getHorizontalDragHelper()?.attach?.(element, {
      allowTouch: false,
      cancelOnOutsidePointerDown: true,
      capturePointer: false,
      draggingClass: options.draggingClass || 'is-dragging',
      maxWidth: Number(options.maxWidth) || 1199,
      suppressClick: true,
      threshold: Number(options.threshold) || 6,
      onStart: () => {
        startScrollLeft = element.scrollLeft;
      },
      onMove: ({ deltaX }) => {
        element.scrollLeft = startScrollLeft - deltaX;
      },
    }) || null;
  }

  window.Express.productBuilderDragScroll = {
    attach,
  };
})();
